'use client';

import * as React from 'react';
export const TimelineGridEventContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") TimelineGridEventContext.displayName = "TimelineGridEventContext";
export function useTimelineGridEventContext() {
  const context = React.useContext(TimelineGridEventContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: `TimelineGridEventContext` is missing. TimelineGrid Event parts must be placed within <TimelineGrid.Event />.');
  }
  return context;
}